module.exports = __webpack_public_path__ + "media/images/home/home-menu-f02296f04ecdd825418bef25676480d7.png";